import { AngularFirestore } from '@angular/fire/compat/firestore';
import 'firebase/firestore';
import {
  Translation,
  TranslocoLoader,
  TranslocoModule,
  provideTransloco
} from '@jsverse/transloco';
import {
  Injectable,
  NgModule,
  InjectionToken,
  Inject,
  ErrorHandler,
  Injector,
  runInInjectionContext,
} from '@angular/core';
import { environment } from '../environments/environment';
import { catchError, map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

// @Injectable({ providedIn: 'root' })
// export class TranslocoHttpLoader implements TranslocoLoader {
//   constructor(private http: HttpClient) { }
//   getTranslation(lang: string) {
//     return this.http.get<Translation>(`${environment.baseUrl}/assets/i18n/${lang}.json`);
//   }
// }

@Injectable({ providedIn: 'root' })
export class TranslocoFirebaseLoader implements TranslocoLoader {
  constructor(
    private firestore: AngularFirestore,
    @Inject(TRANSLATION_MODULES) private modules: string[],
    private errorHandler: ErrorHandler,
    private injector: Injector
  ) {}
  getTranslation(lang: string): Observable<Translation> {
    return runInInjectionContext(this.injector, () => {
      const pages = this.firestore.collection<Translation>('pages');
      return pages.valueChanges({ idField: 'pageName' }).pipe(
        map((pageDocuments: any[]) => {
          const firebaseTrans: Translation = {};
          pageDocuments.forEach(
            (page) => (firebaseTrans[page.pageName] = page[lang])
          );
          return firebaseTrans;
        }),
        catchError((error) => {
          this.errorHandler.handleError(error);
          return of(error);
        })
      );
    });
  }
}
export const TRANSLATION_MODULES = new InjectionToken<string[]>(
  'Translation scopes',
  { factory: () => [] }
);

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: ['en', 'et'],
        defaultLang: 'et',
        fallbackLang: 'et',
        // Remove this option if your application doesn't support changing language in runtime.
        reRenderOnLangChange: true,
        prodMode: environment.production,
      },
      loader: TranslocoFirebaseLoader
    }),
  ],
})
export class TranslocoRootModule {}
